import { Instagram } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Menciones({ datos, seccion }) {
  const menciones = datos.menciones || [];
  if (menciones.length === 0) return null;

  return (
    <section className="xv-seccion" aria-label={seccion.titulo}>
      <div className="xv-seccion-interior">
        <EncabezadoSeccion p="xv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="xv-titulo-menciones" />
        <div className="xv-menciones">
          {menciones.map((m, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <figure className="xv-mencion" data-testid={`xv-mencion-${i}`}>
                <img className="xv-mencion-foto" src={m.foto} alt={`Fotografía de ${m.nombre}`} loading="lazy" />
                <figcaption>
                  <p className="xv-mencion-nombre">{m.nombre}</p>
                  <p className="xv-mencion-rol">{m.rol}</p>
                  {m.instagramUrl && (
                    <a
                      className="xv-mencion-ig"
                      href={m.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Instagram de ${m.nombre}`}
                      data-testid={`xv-enlace-instagram-${i}`}
                    >
                      <Instagram strokeWidth={1.5} />
                    </a>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
